/////////////////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Jaime Rosales 2016 - Forge Developer Partner Services
//
// Permission to use, copy, modify, and distribute this software in
// object code form for any purpose and without fee is hereby granted,
// provided that the above copyright notice appears in all copies and
// that both that copyright notice and the limited warranty and
// restricted rights notice below appear in all supporting
// documentation.
//
// AUTODESK PROVIDES THIS PROGRAM "AS IS" AND WITH ALL FAULTS.
// AUTODESK SPECIFICALLY DISCLAIMS ANY IMPLIED WARRANTY OF
// MERCHANTABILITY OR FITNESS FOR A PARTICULAR USE.  AUTODESK, INC.
// DOES NOT WARRANT THAT THE OPERATION OF THE PROGRAM WILL BE
// UNINTERRUPTED OR ERROR FREE.
/////////////////////////////////////////////////////////////////////////////////

/* eslint-disable */
/* global Autodesk, THREE */
import axios from "axios";
import { toastr } from "react-redux-toastr";
import { BuildingToolbarExtension } from "./toolBarExtension";
import visualClusterExtension from "./visualClusterExtension";
import { setApplyRefPointChecked } from "../../actions/modelsActions";
import Client from "../Client";
import { store } from "../..";

import {
  uploadToS3Bucket,
  updateModelProperties,
} from "../../services/apiHelper";
export let viewer;
let explodeScale = 0;
let startExplosion = null;
let explosionReq;
let isExploding = false;
let outwardExplosion = true;
let startRotation = null;
let rotationReq;
let isRotating = false;
let tileId = "";
let applyRefPoint = false;
let hostDomain;
let camera;
let geometryLoadedEvent = false;
let objectTreeCreatedEvent = false;
let currentModel = null;
let urnLength = 0;
let noOfModelsLoaded = 0;
const url = window.location.href;
export let entitiesPropertiesList = {};
export let modelHierarchy = {};
export let exportTreeData = [];
hostDomain = "/token";

function launchViewer(div, urnIds, id, cameraPosition, viewType, applyRefPnt) {
  tileId = id;
  applyRefPoint = applyRefPnt;
  urnLength = urnIds.length;
  modelHierarchy = {};
  entitiesPropertiesList = {};
  noOfModelsLoaded = 0;

  axios.get("/token").then(async (response) => {
    const token = JSON.parse(response.data);
    if (!token) return;
    let options = {
      env: "MD20ProdEU",
      accessToken: token.access_token,
      api: "streamingV2",
    };

    Autodesk.Viewing.Initializer(options, () => {
      var config3d =
        viewType === 1
          ? {
              extensions: ["BuildingToolbarExtension"],
            }
          : {
              extensions: [],
            };

      let viewerElement = document.getElementById(div);
      if (viewer) {
        viewer.tearDown();
        viewer.finish();
        viewer = null;
      }
      viewer = new Autodesk.Viewing.GuiViewer3D(
        document.getElementById(div),
        config3d
      );
      camera = cameraPosition;

      viewer.start();

      _onLoadModelSuccess(urnIds);
    });
  });
}

function _onLoadModelSuccess(urnIds) {
  loadNextModel(0);
  if (!url.includes("/shared_viewer/")) {
    var x = document.getElementById("snackbar");
    if (x) {
      x.innerText = "Please wait for the extensions to load..";
      x.className = "show";
    }
  }
  /**
   * Nice little inner function.
   * Called within parent function no visibility outside parent function
   * @param {number} modelIndex
   */
  function loadNextModel(modelIndex) {
    let _modelIndex = modelIndex;

    axios
      .get("/token")
      .then(async (response) => {
        const accessToken = JSON.parse(response.data);
        if (!accessToken) return;
        let urn = urnIds[_modelIndex];
        let documentId = "urn:" + urn;
        Autodesk.Viewing.Initializer(
          {
            env: "MD20ProdUS",
            accessToken: accessToken.access_token,
            api: "streamingV2",
          },
          () => {
            Autodesk.Viewing.Document.load(
              documentId,
              onDocumentLoadSuccess,
              onDocumentLoadFailure
            );
          }
        );

        _modelIndex++;
        if (_modelIndex < urnIds.length) {
          window.setTimeout(loadNextModel(_modelIndex), 5000);
        }
      })
      .catch((err) => {
        console.log("error getting token", err);
      });
  }
}

function onDocumentLoadSuccess(doc) {
  let viewables = doc.getRoot().getDefaultGeometry();
  viewer
    .loadDocumentNode(doc, viewables, {
      keepCurrentModels: true,
      globalOffset: { x: 0, y: 0, z: 0 },
      applyRefPoint: applyRefPoint,
    })
    .then((i) => {
      // documented loaded, any action?
      viewer.addEventListener(
        Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
        async function (event) {
          if (viewer.model) {
            await viewer.model
              .getDocumentNode()
              .getDocument()
              .downloadAecModelData();

            onGeometryLoaded();
          }
        }
      );
      //TODO: Check if we get instance tree only after OBJECT_TREE_CREATED_EVENT.
      viewer.addEventListener(
        Autodesk.Viewing.OBJECT_TREE_CREATED_EVENT,
        function (event) {
          
          objectTreeCreatedEvent = true;
          // currentModel = event.model;
          loadExtensions(event.model);
        }
      );
    });

  viewer.setDisplayEdges(false);
  viewer.setProgressiveRendering(true);
  viewer.setGroundReflection(false);
  viewer.setGroundShadow(false);
  viewer.setQualityLevel(false, false);
  viewer.setGroundReflectionAlpha(0);
  viewer.hideLines(true);
  viewer.setOptimizeNavigation(true);

  let viewCubeUiExt;
  viewer.loadExtension("Autodesk.ViewCubeUi").then((cube) => {
    viewCubeUiExt = viewer.getExtension("Autodesk.ViewCubeUi");
    viewCubeUiExt.setVisible(true);
    viewCubeUiExt.displayHomeButton(true);
    viewCubeUiExt.refreshCube();
  });
}

function onGeometryLoaded() {
  if (camera) {
    viewer.restoreState(JSON.parse(camera), true);
  }
  geometryLoadedEvent = true;
}

const UploadPropertiesToS3 = async (model, storeState) => {
  let modelName = "";
  let modelURN = "";
  let modelId = "";

  try {
    if (
      storeState.models &&
      storeState.models.selectedModel &&
      storeState.models.selectedModel.length >= 1
    ) {
      let smodel = storeState.models.selectedModel.find(
        (m) => m.modelURN === model.loader.svfUrn
      );
      if (smodel) {
        modelName = smodel.displayName.split(".").slice(0, -1).join(".");
        modelURN = smodel.modelURN;
        modelId = smodel.uniqueId;

        let metadata = await getMetadata(modelURN);
        const guidReference = metadata.data.metadata.find((data) => {
          return data.role === "3d";
        });

        if (!guidReference) return;

        let metadataGuidResponse = await requestMetadataGuidData(
          modelURN,
          guidReference.guid
        );

        let res = await getMetadataProperties(modelURN, guidReference.guid);

        let blob = new Blob([JSON.stringify(res.data)], {
          type: "text/plain",
        });

        const userEmail = localStorage.getItem("email")
        var json = new File([blob], modelName + "_" + modelURN + ".json");
        let params = {
          Bucket: process.env.REACT_APP_COTRINITY_ENV=== "development" ?  "digitalflowplanning/modelproperties/development" : "digitalflowplanning/modelproperties/production" ,
          Key: userEmail + "_" + modelName + "_" + modelURN + ".json",
          Body: json,
        };
        let s3Link = await uploadToS3Bucket(params);
        updateModelProperties(
          modelId,
          modelURN,
          modelName,
          s3Link.Location,
          s3Link.TimeStamp
        );
      }
    }
  } catch (err) {
    console.log("Error in property set ", err);
  }
};

const getMetadata = async (modelUrn) => {
  return new Promise(async (resolve, reject) => {
    try {
      axios.get("/token").then(async (response) => {
        const token = JSON.parse(response.data);

        if (!token) return;

        const config = {
          method: "get",
          url:
            "https://developer.api.autodesk.com/modelderivative/v2/designdata/" +
            modelUrn +
            " /metadata",
          headers: {
            Authorization: "Bearer " + token.access_token,
          },
        };

        // let obj = axios.get("/get/properties").then(async (res) => {
        axios(config)
          .then(async (res) => {
            resolve(res.data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    } catch (err) {
      reject(err);
    }
  });
};

const requestMetadataGuidData = async (modelUrn, guid) => {
  return new Promise(async (resolve, reject) => {
    try {
      axios.get("/token").then(async (response) => {
        const token = JSON.parse(response.data);

        if (!token) return;
        const config = {
          method: "get",
          url:
            "https://developer.api.autodesk.com/modelderivative/v2/designdata/" +
            modelUrn +
            " /metadata/" +
            guid,
          headers: {
            Authorization: "Bearer " + token.access_token,
          },
        };

        // let obj = axios.get("/get/properties").then(async (res) => {
        axios(config)
          .then(async (res) => {
            if (res.status === 202) {
              resolve(await requestMetadataGuidData(modelUrn, guid));
            } else {
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    } catch (err) {
      reject(err);
    }
  });
};

const getMetadataProperties = async (modelUrn, guid) => {
  return new Promise(async (resolve, reject) => {
    try {
      axios.get("/token").then(async (response) => {
        const token = JSON.parse(response.data);

        if (!token) return;
        const config = {
          method: "get",
          url:
            "https://developer.api.autodesk.com/modelderivative/v2/designdata/" +
            modelUrn +
            " /metadata/" +
            guid +
            "/properties?forceget=true",
          headers: {
            Authorization: "Bearer " + token.access_token,
          },
        };

        // let obj = axios.get("/get/properties").then(async (res) => {
        axios(config)
          .then(async (res) => {
            if (res.status === 202) {
              resolve(getMetadataProperties(modelUrn, guid));
            } else {
              resolve(res);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    } catch (err) {
      reject(err);
    }
  });
};

const getPropertySet = async (model, allDbIds) => {
  return new Promise(async (resolve, reject) => {
    const perLoopDbids = 10000;
    var allProperties = {};
    var count = allDbIds.length / perLoopDbids;
    if (model) {
      for (var i = 0; i < count; i++) {
        var tempDbIds = allDbIds.splice(0, perLoopDbids);

        var propsSet = await model.getPropertySetAsync(tempDbIds);

        allProperties = { ...allProperties, ...propsSet.map };
      }
    }
    resolve(allProperties);
  });
};

//TODO : Check extension loading
function loadExtensions(currentModel) {
  let dataComputed = (data) => {
    modelHierarchy[currentModel.loader.svfUrn] = data;
    let storeState = store.getState();

    if (urnLength === 1) {
      UploadPropertiesToS3(currentModel, storeState);
    }
    viewer.loadExtension("Autodesk.VisualClusters").then(() => {
      viewer.loadExtension("visualClusterExtension");
      viewer.loadExtension("BuildingToolbarExtension");
      viewer.loadExtension("Autodesk.AEC.LevelsExtension");
      var x = document.getElementById("snackbar");
      ++noOfModelsLoaded;
      if (x && noOfModelsLoaded === urnLength) {
        x.innerText = "Extensions loaded successfully!";
        x.className = "show";
        setTimeout(function () {
          x.className = x.className.replace("show", "");
        }, 3000);
      }
    });
  };

  if (!url.includes("/shared_viewer/")) {
    buildModelTree(currentModel, dataComputed);
  }

  // var treeContent = buildTreeView();
}

function setCamera() {
  if (camera) {
    viewer.restoreState(JSON.parse(camera), true);
  }
}

function onDocumentLoadFailure(viewerErrorCode) {
  if (!url.includes("/shared_viewer/")) {
    if (parseInt(viewerErrorCode) === 9) {
      const msg = "Please try again later, the file is still being converted";
      toastr.error(msg);
    }
  }
  console.log(viewerErrorCode);
}

//Get token from server
function getTokenDF(_callback) {
  axios.get(hostDomain, function (data, status) {
    let response = JSON.parse(data);
    _callback(response.access_token, response.expires_in);
  });
}

const Helpers = {
  launchViewer,
};

function buildTreeView(model) {
  let treeData = [];

  viewer.model.getPropertySet([viewer.model.getRootId()], (elements) => {
    let treeNode = Object.keys(elements.map);

    treeNode.map((element) => {
      let splitNode = element.split("/");
      let tempLabel = splitNode[0];
      let tempValue = splitNode[1];
      if (splitNode[1] == undefined) {
        tempValue = " ";
        splitNode[1] = " ";
      }

      if (treeData.length > 0) {
        const parent = treeData
          .find((test) => {
            if (test.label === "select all") {
              return test;
            }
          })
          .children.find((child) => {
            if (child.label === splitNode[0]) return child;
          });

        if (parent) {
          if (
            treeData
              .find((test) => {
                if (test.label === "select all") {
                  return test;
                }
              })
              .children.find((child) => {
                if (child.label === splitNode[0]) return child;
              }).children == undefined
          )
            treeData
              .find((test) => {
                if (test.label === "select all") {
                  return test;
                }
              })
              .children.find((child) => {
                if (child.label === splitNode[0]) return child;
              }).children = [];

          if (
            !treeData
              .find((test) => {
                if (test.label === "select all") {
                  return test;
                }
              })
              .children.find((child) => {
                if (child.label === splitNode[0]) return child;
              })
              .children.find((grandChild) => {
                grandChild.value === tempValue;
              })
          ) {
            const math = Math.floor(Math.random() * 100000);
            treeData
              .find((test) => {
                if (test.label === "select all") {
                  return test;
                }
              })
              .children.find((child) => {
                if (child.label === splitNode[0]) return child;
              })
              .children.push({
                value: tempValue + "/" + math,
                label: splitNode[1],
              });
          }
        } else {
          const math = Math.floor(Math.random() * 100000);
          treeData
            .find((test) => {
              if (test.label === "select all") return test;
            })
            .children.push({
              value: tempLabel + "//" + math,
              label: splitNode[0],
              children: [
                { value: tempValue + "/" + math, label: splitNode[1] },
              ],
            });
        }
      } else {
        const math = Math.floor(Math.random() * 100000);
        treeData.push({
          value: "select all",
          label: "select all",
          children: [
            {
              value: tempLabel + "//" + math,
              label: splitNode[0],
              children: [
                { value: tempValue + "/" + math, label: splitNode[1] },
              ],
            },
          ],
        });
      }
    });
    exportTreeData = treeData;
  });
}

function buildModelTree(model, dataComputed) {
  //builds model tree recursively

  function _buildModelTreeRec(node, dataComputed) {
    it.enumNodeChildren(node.dbId, function (childId) {
      node.children = node.children || [];

      var childNode = {
        dbId: childId,
        name: String(it.getNodeName(childId)),
      };

      ++counter;
      dbIdList[childId] = {};

      model.getProperties(childId, (elements) => {
        let externalId = elements.externalId;
        let splitArr = externalId.split("-");
        childNode.externalId = parseInt(splitArr[splitArr.length - 1], 16);
        for (const property of elements.properties) {
          Object.assign(dbIdList[childId], {
            [property.displayName]: property.displayValue,
          });
        }
        Object.assign(dbIdList[childId], {
          ["UniqueName"]: childNode.name,
        });
        Object.assign(dbIdList[childId], {
          ["ExternalId"]: childNode.externalId,
        });
        --counter;
        if (counter === 0) {
          dataComputed(rootNode);
        }
      });

      node.children.push(childNode);
      entitiesPropertiesList[model.loader.svfUrn] = dbIdList;

      _buildModelTreeRec(childNode, dataComputed);
    });
  }

  //get model instance tree and root component
  var it = model.getData().instanceTree;

  var rootId = it.getRootId();

  var rootNode = {
    modelId: model.id,
    dbId: rootId,
    name: it.getNodeName(rootId),
  };
  var counter = 0;

  var dbIdList = {};
  _buildModelTreeRec(rootNode, dataComputed);
}

export default Helpers;
